import React, { useState, useEffect } from 'react';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { sum } from 'd3-array';
import styled from 'styled-components';

import Link from '../elements/link';
import { initialOption, parseGiss, initialDataZoom } from './common';

const Graph = styled.div`
   width: 100%;
    box-sizing: border-box;
    margin-right: auto;
    margin-left: auto;
    padding-top: 1.5em;
    padding-bottom: 1.5em;
`;

const Source = styled.div`
  font-size: small;
`;

const GraphTitle = styled.div`
  font-weight: bold;
`;

const GraphDescription = styled.div`
`;

const ManMadeEmissions = () => {
  const [option, updateOption] = useState(initialOption());

  const loadData = () => {
    const data = [
      { name: 'Fossil fuels\nconsumption', value: 48.9 - 12.2 - 4.4, color: '#c23531' },
      { name: 'Agriculture and\ndeforestation', value: 12.2, color: '#749f83' },
      { name: 'Non-energy related\nindustrial processes', value: 4.4, color: '#546570' },
    ].reverse();

    // Percentage
    const total = sum(data, d => d.value);
    data.forEach((d) => {
      d.value /= total / 100;
    });

    const newOption = initialOption();

    newOption.grid.left = 130;

    newOption.xAxis.type = 'value';
    newOption.xAxis.axisLabel = { formatter: '{value}%' };
    newOption.grid.bottom = 50;

    newOption.yAxis.data = data.map(d => d.name);

    newOption.tooltip.trigger = 'none';

    newOption.series = [
      {
        type: 'bar',
        data: echarts.util.map(data, d => ({
          value: d.value,
          itemStyle: {
            normal: {
              color: d.color,
            },
          },
        })),
        label: {
          normal: {
            show: true,
            position: 'right',
            formatter(e) {
              return `${Math.round(e.data.value)}%`;
            },
          },
        },
      },
    ];
    updateOption(newOption);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Graph>
      <GraphTitle>Man-made greenhouse gas emissions in 2010</GraphTitle>
      <GraphDescription>% of total</GraphDescription>
      <ReactEcharts
        option={option}
        notMerge
      />
      <Source>
        Source:
        {' '}
        <Link outward href="https://www.accenture.com/t00010101T000000__w__/br-pt/_acnmedia/PDF-11/Accenture-Strategy-Energy-Perspectives-Consequences-COP21.pdf">Accenture Energy Perspectives - Consequences of COP21 for the Oil and Gas Industry</Link>
        , Fig. 12 p14.
        <br />
            A fascinating Sankey diagram shows this in much more details
        {' '}
        <Link outward href="https://www.ecofys.com/files/files/world-ghg-emission-flow-chart-2012_v9-c-asn-ecofys-2016_02.pdf">here</Link>
        .
      </Source>
    </Graph>
  );
};

export default ManMadeEmissions;
